import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const HideShowModulesModalWrapper = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .btn-success {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
  }
  .form-title {
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3 {
      font-size: 1rem;
      color: #0B2A1B;
    }
  }
  .form-body {
    padding: 24px;
  }
  .ant-checkbox-wrapper {
    font-size: 14px;
    margin-left: 0;
  }
  /* antd adds margin-left to each checkbox after the first (for inline groups),
     which indents every option but the first in our vertical layout. Reset it. */
  .ant-checkbox-wrapper + .ant-checkbox-wrapper,
  .ant-checkbox-group-item + .ant-checkbox-group-item {
    margin-left: 0;
  }
`;

export default WithDirection(HideShowModulesModalWrapper);
